export default __webpack_public_path__ + "static/denny_lee-d22ca5c855263b88e78fade7ddca3f4a.jpg";